var _excluded = ["entity", "customClasses"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
var WebformHidden = function WebformHidden(_ref) {
  var entity = _ref.entity,
    customClasses = _ref.customClasses,
    fieldProps = _objectWithoutProperties(_ref, _excluded);
  var key = entity.get('#webform_key');
  var wrapperClassNames = c('WebformHidden', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(Field, {
    className: "hidden",
    name: key,
    type: "text",
    value: fieldProps.values[key]
  }));
};
export default WebformHidden;